import React from 'react';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fluidAdIdPrefix = 'adspot-fluid-pos';
var inlineAdbridgPrefix = 'adb-ah-srp-insearch-';
var insertFluidAds = function insertFluidAds(listings) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    adRowStyle = _ref.adRowStyle;
  var newListings = [];
  var numberOfListingsPerAd = 6;
  listings.forEach((listing, index) => {
    newListings.push(listing);
    if (index % numberOfListingsPerAd === numberOfListingsPerAd - 1) {
      var adIndex = Math.floor(index / numberOfListingsPerAd);
      var adId = "".concat(fluidAdIdPrefix).concat(adIndex + 1);
      var adBridgId = "".concat(inlineAdbridgPrefix).concat(adIndex + 1);
      newListings.push(___EmotionJSX("div", {
        css: adRowStyle,
        key: adBridgId
      }, ___EmotionJSX(AdSpot, {
        gpt: {
          adId,
          strategy: 'window.onload'
        },
        adbridg: {
          id: adBridgId,
          adClass: 'adb-ah-srp-insearch'
        }
      })));
    }
  });
  return newListings;
};
export default insertFluidAds;